export const initialUserData = {
  email: '',
  firstName: '',
  lastName: '',
  state: '',
  other: '',
  diagnosis_ids: [],
  symptom_ids: [],
  // info about affiliate that we need to carry on through the onboarding process
  affiliate: null,
  // Set when the user moves off the first question. The steps have their own
  // routes, so this says whether a later step was reached by walking the flow
  // or by landing on its URL with no answers behind it. It lives here because
  // this is the only state above the router, and it stays out of the register
  // payload, which is built from an explicit list of fields.
  hasStartedOnboarding: false,
  // The GI condition answer. `diagnosis_ids` cannot stand in for it, because an
  // empty list means both "answered no" and "not answered yet".
  hasGiCondition: null,
  // The "where you're at right now" answer, shaped the way /register takes it:
  // { answer, description }. Null while the question is unanswered or skipped.
  current_status: null,
};
